import dayjs from "../config/dayjs";

export const dispatchStatusConfig = {
  "entrega não confirmada": {
    backgroundColor: "#475569",
    textColor: "#FFFFFF",
    iconColor: "#475569",
    borderColor: "transparent",
    tooltip: "Mensagem aceita, aguardando confirmação de entrega.",
  },
  espera: {
    backgroundColor: "#E8EEF9",
    textColor: "#64748B",
    iconColor: "#C5CEDC",
    borderColor: "transparent",
    tooltip: "Mensagem aguardando envio.",
  },
  falha: {
    backgroundColor: "#ED1C02",
    textColor: "#FFFFFF",
    iconColor: "#E71313",
    borderColor: "transparent",
    tooltip: "Ocorreu uma falha no envio.",
  },
  entregue: {
    backgroundColor: "#2563EB",
    textColor: "#FFFFFF",
    iconColor: "#2563EB",
    borderColor: "transparent",
    tooltip: "Mensagem entregue ao destinatário.",
  },
  lida: {
    backgroundColor: "#6B08B3",
    textColor: "#FFFFFF",
    iconColor: "#6B08B3",
    borderColor: "transparent",
    tooltip: "Mensagem visualizada pelo destinatário.",
  },
  "sem whatsapp": {
    backgroundColor: "#ED9A07",
    textColor: "#FFFFFF",
    iconColor: "#EB9600",
    borderColor: "transparent",
    tooltip: "Disparo sem canal de WhatsApp configurado.",
  },
  desconhecido: {
    backgroundColor: "#ED9A07",
    textColor: "#FFFFFF",
    iconColor: "#EB9600",
    borderColor: "transparent",
    tooltip: "Status não identificado.",
  },
  default: {
    backgroundColor: "#E8EEF9",
    textColor: "#64748B",
    iconColor: "#C5CEDC",
    borderColor: "transparent",
    tooltip: "Status não identificado.",
  },
};

export const createDefaultDispatchFilters = () => ({
  status: [],
  channel: [],
  startDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
  endDate: dayjs().format("YYYY-MM-DD"),
});

export const dispatchStatusOptions = [
  { value: "lida", label: "Lida" },
  { value: "entregue", label: "Entregue" },
  { value: "falha", label: "Falha" },
  { value: "desconhecido", label: "Desconhecido" },
  { value: "entrega não confirmada", label: "Entrega não confirmada" },
];

export const dispatchChannelOptions = [
  { value: "WPP", label: "WhatsApp" },
  { value: "SMS", label: "SMS" },
  { value: "E-mail", label: "E-mail" },
];

export const formatChannelType = (type) => {
  const normalizedType = String(type || "")
    .trim()
    .toLowerCase();

  if (
    normalizedType === "whatsapp_api" ||
    normalizedType === "whatsapp_web"
  ) {
    return "WhatsApp";
  }

  if (normalizedType === "sms") {
    return "SMS";
  }

  if (normalizedType === "email") {
    return "E-mail";
  }

  return type || "-";
};

export const formatPhoneNumber = (rawValue) => {
  if (!rawValue) return "-";

  const rawText = String(rawValue).trim();
  if (rawText.toLowerCase() === "shared") return "Padrão";

  const digitsOnly = rawText.replace(/\D/g, "");
  if (!digitsOnly) return rawText;

  // Keep last 13 digits max (country + area + number)
  const normalized = digitsOnly.slice(-13);

  // +55 (AA) 9 9999-9999 (mobile) or +55 (AA) 9999-9999 (landline)
  if (normalized.length === 13 && normalized.startsWith("55")) {
    const area = normalized.slice(2, 4);
    const local = normalized.slice(4);
    if (local.length === 9) {
      return `+55 (${area}) ${local.slice(0, 1)} ${local.slice(1, 5)}-${local.slice(5)}`;
    }
    if (local.length === 8) {
      return `+55 (${area}) ${local.slice(0, 4)}-${local.slice(4)}`;
    }
  }
  if (normalized.length === 12 && normalized.startsWith("55")) {
    const area = normalized.slice(2, 4);
    const local = normalized.slice(4);
    if (local.length === 8) {
      return `+55 (${area}) ${local.slice(0, 4)}-${local.slice(4)}`;
    }
  }

  // Local without country prefix (assume +55)
  if (normalized.length === 11) {
    return `+55 (${normalized.slice(0, 2)}) ${normalized.slice(2, 3)} ${normalized.slice(3, 7)}-${normalized.slice(7)}`;
  }
  if (normalized.length === 10) {
    return `+55 (${normalized.slice(0, 2)}) ${normalized.slice(2, 6)}-${normalized.slice(6)}`;
  }

  // Fallback: keep explicit country prefix when available.
  if (normalized.length > 11) {
    return `+${normalized}`;
  }
  return rawText;
};

export const formatChatOpen = (value) => {
  if (value === true) return "Sim";
  if (value === false) return "Não";
  return "-";
};

export const formatDate = (value) => {
  if (!value) return "-";

  return dayjs(value).format("DD/MM/YYYY");
};

export const formatDateTime = (dateValue, timeValue) => {
  if (!dateValue) return "-";

  const formattedDate = formatDate(dateValue);
  const formattedTime = timeValue
    ? dayjs(`2000-01-01T${timeValue}`).format("HH:mm")
    : "";

  return formattedTime ? `${formattedDate} ${formattedTime}` : formattedDate;
};

export const formatCampaignStatus = (status) => {
  const normalizedStatus = String(status || "").toLowerCase();

  if (normalizedStatus === "active" || normalizedStatus === "true") {
    return "Ativo";
  }

  if (normalizedStatus === "false" || normalizedStatus === "desativado") {
    return "Desativado";
  }

  return status || "-";
};

export const getCampaignStatusMeta = (status) => {
  const normalizedStatus = String(status || "")
    .trim()
    .toLowerCase();

  if (normalizedStatus === "true" || normalizedStatus === "active" || normalizedStatus === "ativo") {
    return {
      label: "Ativado",
      color: "#34c759",
      icon: "AlarmOn",
    };
  }

  return {
    label: "Desativado",
    color: "#94a3b8",
    icon: "AlarmOff",
  };
};

export const formatCampaignType = (type) => {
  const normalizedType = String(type || "")
    .trim()
    .toLowerCase();

  if (normalizedType === "single") {
    return "Disparo único";
  }

  if (normalizedType === "recurring") {
    return "Recorrência";
  }

  return type || "Tipo não informado";
};

export const formatTemplateChannelLabel = (channel) => {
  const normalizedChannel = String(channel || "").toLowerCase();

  if (
    normalizedChannel === "whatsapp_api" ||
    normalizedChannel === "whatsapp_web"
  ) {
    return "WhatsApp";
  }

  if (normalizedChannel === "sms") {
    return "SMS";
  }

  if (normalizedChannel === "email") {
    return "E-mail";
  }

  return channel || "Modelo";
};

export const normalizePreviewChannel = (channel) => {
  const normalizedChannel = String(channel || "").toLowerCase();

  if (normalizedChannel === "whatsapp") {
    return "whatsapp_api";
  }

  if (normalizedChannel === "e-mail") {
    return "email";
  }

  return normalizedChannel || "";
};

export const buildTemplatePreview = (template) => {
  try {
    const source = template?.messageJson || template?.message_json;
    const parsed = typeof source === "string" ? JSON.parse(source) : source;
    const channel = normalizePreviewChannel(
      template?.channel_type || template?.type,
    );
    const legacyTemplateVariables = Array.isArray(parsed?.template?.variables)
      ? parsed.template.variables[0] || {}
      : {};
    const fallbackEmailContent =
      channel === "email"
        ? parsed?.content ||
          parsed?.html ||
          parsed?.body ||
          parsed?.message ||
          parsed?.template?.html ||
          template?.content ||
          template?.html ||
          template?.body ||
          ""
        : "";
    const rawMessages = Array.isArray(parsed?.messages)
      ? parsed.messages
      : fallbackEmailContent
        ? [{ content: fallbackEmailContent, type: "html" }]
        : [];

    const messages = rawMessages.map((item, index) => {
      const rawMessage =
        item?.message ??
        item?.content ??
        item?.html ??
        item?.body ??
        item?.text ??
        "";
      const rawMessageObject =
        typeof rawMessage === "object" && rawMessage !== null ? rawMessage : {};
      const content =
        typeof rawMessage === "string"
          ? rawMessage
          : rawMessageObject?.content ||
            rawMessageObject?.html ||
            rawMessageObject?.body ||
            rawMessageObject?.text ||
            "";
      const buttonsFromMessage = Array.isArray(rawMessageObject?.buttons)
        ? rawMessageObject.buttons
        : [];
      const buttonsFromItem = Array.isArray(item?.buttons) ? item.buttons : [];
      const header = item?.header || rawMessageObject?.header;

      return {
        ...rawMessageObject,
        id: item?.id || `msg-${index}`,
        type: item?.type || rawMessageObject?.type || (channel === "email" ? "html" : "text"),
        content,
        fromMe: item?.fromMe ?? true,
        ...(header ? { header } : {}),
        email_subtitle:
          item?.email_subtitle ||
          rawMessageObject?.email_subtitle ||
          parsed?.email_subtitle ||
          legacyTemplateVariables?.emailTitle ||
          legacyTemplateVariables?.title01 ||
          template?.email_subtitle ||
          "",
        email_accent_color:
          item?.email_accent_color ||
          rawMessageObject?.email_accent_color ||
          parsed?.email_accent_color ||
          template?.email_accent_color ||
          "",
        buttons: buttonsFromMessage.length
          ? buttonsFromMessage
          : buttonsFromItem,
      };
    }).filter((message) => String(message.content || "").trim());

    return {
      templateId: String(template?.id || ""),
      title: template?.title || "Modelo selecionado",
      channel,
      channelLabel: formatTemplateChannelLabel(channel),
      messages,
    };
  } catch (error) {
    console.error("Erro ao montar preview do modelo da campanha:", error);

    return {
      templateId: String(template?.id || ""),
      title: template?.title || "Modelo selecionado",
      channel: normalizePreviewChannel(
        template?.channel_type || template?.type,
      ),
      channelLabel: formatTemplateChannelLabel(
        template?.channel_type || template?.type,
      ),
      messages: [],
    };
  }
};

export const dispatchTableLocaleText = {
  noRowsLabel: "Nenhum disparo encontrado para esta campanha no último mês.",
  footerRowSelected: (count) =>
    count !== 1
      ? `${count.toLocaleString()} linhas selecionadas`
      : `${count.toLocaleString()} linha selecionada`,
  footerTotalRows: "Total de linhas:",
  MuiTablePagination: {
    labelRowsPerPage: "Linhas por página:",
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`,
  },
};
